import { useEffect, useRef } from 'react';
import { FlattenInterpolation, ThemeProps } from 'styled-components';
import {
  useModelForm, FormInput, TextareaInput, ThemeType,
  useIsAutoSave,
} from '../../../../..';

export function ModelTextarea({
  field = '',
  label = '',
  placeholder = '',
  labelStyles = '',
  valueOverride,
  errorOverride = '',
  rows = 5,
  cols = 5,
  disabled = false,
  touchOverride = false,
  maxLength,
  onBlur = () => { },
  mutateValue = (newValue) => newValue,
  onVisibleChange,
  containerCss,
  required = false,
  onChange,
  maxHeight = 132,
  minHeight = 40,
}: {
  field?: string,
  label?: string,
  placeholder?: string,
  rows?: number,
  cols?: number,
  labelStyles?: string,
  valueOverride?: string,
  errorOverride?: string,
  disabled?: boolean,
  touchOverride?: boolean,
  maxLength?: number,
  onBlur?: (targetValue: string) => void,
  mutateValue?: (newValue: string) => any,
  onVisibleChange?: (visible: boolean) => void,
  containerCss?: FlattenInterpolation<ThemeProps<ThemeType>> | string,
  required?: boolean,
  onChange?: (value: string) => void,
  maxHeight?: number,
  minHeight?: number
}) {
  const {
    visible, errors, value, update, warnings,
  } = useModelForm(field, valueOverride, errorOverride);

  const changed = useRef<boolean>(false);

  const { isAutoSave } = useIsAutoSave();

  useEffect(() => {
    onVisibleChange?.(visible);
  }, [visible]);

  const blur = (targetValue: string) => {
    onBlur(targetValue);
    if (changed.current && isAutoSave) {
      update({ [field]: mutateValue(targetValue) });
    }
    changed.current = false;
  };

  const onValueChange = (newValue: string) => {
    changed.current = true;
    update(
      { [field]: mutateValue(newValue) },
      isAutoSave,
    );
    onChange?.(newValue);
  };

  return (
    <FormInput visible={visible} css={containerCss}>
      <TextareaInput
        id={field}
        label={label}
        labelStyles={labelStyles}
        placeholder={placeholder}
        value={value}
        errors={errors}
        warnings={warnings}
        rows={rows}
        cols={cols}
        disabled={disabled}
        touchOverride={touchOverride}
        maxLength={maxLength}
        onBlur={blur}
        onChange={onValueChange}
        required={required}
        maxHeight={maxHeight}
        minHeight={minHeight}
      />
    </FormInput>
  );
}
